import classNames from 'classnames';
import React from 'react';

import { Text, TextButton } from '../../../../components/common';
import { LeftRightLayout } from '../../../../components/layout/left-right-layout/left-right-layout';
import { Translate } from '../../../../components/translate/translate';

import styles from './retry-panel.scss';

interface Props {
  onRetryAllClick(): void;
  failedCount: number;
  canceledCount: number;
  className?: string;
}

function getMessage(failedCount: number, canceledCount: number): string {
  if (failedCount > 0) {
    if (canceledCount > 0) {
      return 'operation-panel.file-upload.retry.failed-or-canceled';
    }

    return 'operation-panel.file-upload.retry.failed';
  }

  return 'operation-panel.file-upload.retry.canceled';
}

export const RetryPanel: React.FunctionComponent<Props> = ({
  className,
  failedCount,
  canceledCount,
  onRetryAllClick,
}: Props) => (
  <LeftRightLayout className={classNames(styles.retryPanel, className)}>
    <Text size="small" secondary>
      <Translate
        transKey={getMessage(failedCount, canceledCount)}
        params={{ count: failedCount + canceledCount }}
      />
    </Text>

    <Text size="small">
      <TextButton onClick={onRetryAllClick}>
        <Translate transKey="operation-panel.file-upload.retry.retry-all" />
      </TextButton>
    </Text>
  </LeftRightLayout>
);
